import { genId } from "../../../utils"

const frontMatterSchema = {
  name: 'frontMatterSchema',
  _id: genId(),
  content: [
    {
      name: 'root',
      type: 'Container',
      displaySettings: { as: 'Container', className: 'report-root-container schema-print-preview' },
      children: [
        {
          name:'exportFrontMatter',
          type:'exportFrontMatter'
        }
      ]
    },

  ]
}

export { frontMatterSchema }